export default __webpack_public_path__ + "static/media/Sunset-Edited-960px-294px.49efd9b4.jpg";